<template>
  <p-container>
    <p-row>
      <p-col xs12 md6>
        <om-dynamic-form
          v-model="output"
          :definition="formDefinition"
        ></om-dynamic-form>
      </p-col>
      <p-col>
        <p-request-alert v-model="errorResponse"></p-request-alert>
      </p-col>
      <!-- <p-col xs8>
        <div><div v-html="JSON.stringifyToHTML(output.getDTO(), undefined, 2)"></div></div>
      </p-col> -->
    </p-row>
  </p-container>
</template>

<script lang="ts">
  import Vue from 'vue';
  import CreateDynamicFormRequestViewModel from '../../../services/v1/viewModel/resource/CreateDynamicFormRequestViewModel';
  import DynamicFormResourceViewModel from '../../../services/v1/viewModel/resource/DynamicFormResourceViewModel';

  export default Vue.extend({
    auth: true,
    data: () => ({
      isLoading: false,
      errorResponse: undefined as any,
      output: new CreateDynamicFormRequestViewModel(),
      formDefinition: new DynamicFormResourceViewModel(),
    }),
    async mounted() {
      this.isLoading = true;
      try {
        this.formDefinition = await this.$service.api.dynamicForms.getKitchenSink();
      } catch (error) {
        this.errorResponse = error;
      }
      this.isLoading = false;
    },
    methods: {
      onSubmit() {
        this.isLoading = true;
        try {
          this.$service.api.dynamicForms.createDynamicForm(this.output);
        } catch (error) {
          this.errorResponse = error;
        }
        this.isLoading = false;
      },
    },
  });
</script>
